import { IEditedPost, IGooglePost } from '@app/api/models/googlePost.model';
import { createAction, props } from '@ngrx/store';

export enum GooglePostActionTypes {
  PUBLISH_POST_ATTEMPT = '[Google Post] Publish post Attempt',
  PUBLISH_POST_SUCCESS = '[Google Post] Publish post Success',
  PUBLISH_POST_FAILURE = '[Google Post] Publish post Failure',

  EDIT_POST_ATTEMPT = '[Google Post]EDIT post Attempt',
  EDIT_POST_SUCCESS = '[Google Post]EDIT post Success',
  EDIT_POST_FAILURE = '[Google Post]EDIT post Failure',

  UPDATE_IMAGES_STORE = '[Google Post] Update Post images',
  UPDATE_IMAGES_STORE_SUCCESS = '[Google Post] Update Post images success',

  UPDATE_IMAGES_STORE_EDIT_ATTEMPT = '[Google Post] Update Post images Edit Attempt',
  UPDATE_IMAGES_STORE_EDIT_SUCCESS = '[Google Post] Update Post images Edit Success',

  REMOVE_IMAGE_STORE = '[Google Post] Remove Post images',
  REMOVE_IMAGE_STORE_SUCCESS = '[Google Post] Remove Post images success',

  GET_PULISHED_POSTS_ATTEMPT = '[Google Post] Get published Posts Attempt',
  GET_PULISHED_POSTS_SUCCESS = '[Google Post] Get published Posts Success',
  GET_PULISHED_POSTS_FAILURE = '[Google Post] Get published Posts Failure',

  DELETE_POST_ATTEMPT = '[Google Post] Delete Post Attempt',
  DELETE_POST_SUCCESS = '[Google Post] Delete Post Success',
  DELETE_POST_FAILURE = '[Google Post] Delete Post Failure',
}

export const publishPostAttempt = createAction(GooglePostActionTypes.PUBLISH_POST_ATTEMPT, props<IGooglePost>());
export const publishPostFailure = createAction(GooglePostActionTypes.PUBLISH_POST_FAILURE);
export const publishPostSuccess = createAction(GooglePostActionTypes.PUBLISH_POST_SUCCESS);

export const editPostAttempt = createAction(GooglePostActionTypes.EDIT_POST_ATTEMPT, props<IEditedPost>());
export const editPostFailure = createAction(GooglePostActionTypes.EDIT_POST_FAILURE);
export const editPostSuccess = createAction(GooglePostActionTypes.EDIT_POST_SUCCESS);

export const deletePostAttempt = createAction(GooglePostActionTypes.DELETE_POST_ATTEMPT, props<any>());
export const deletePostFailure = createAction(GooglePostActionTypes.DELETE_POST_FAILURE);
export const deletePostSuccess = createAction(GooglePostActionTypes.DELETE_POST_SUCCESS);

export const updateImageStoreForEditAttempt = createAction(GooglePostActionTypes.UPDATE_IMAGES_STORE_EDIT_ATTEMPT, props<any>());
export const updateImagesStoreForEditSucess = createAction(GooglePostActionTypes.UPDATE_IMAGES_STORE_EDIT_SUCCESS, props<any>());

export const updateImagesStore = createAction(GooglePostActionTypes.UPDATE_IMAGES_STORE, props<any>());
export const updateImagesStoreSucess = createAction(GooglePostActionTypes.UPDATE_IMAGES_STORE_SUCCESS, props<any>());

export const deleteImageStore = createAction(GooglePostActionTypes.REMOVE_IMAGE_STORE, props<any>());
export const deleteImageStoreSuccess = createAction(GooglePostActionTypes.REMOVE_IMAGE_STORE_SUCCESS, props<any>());

export const getPublishedPostsAttempt = createAction(GooglePostActionTypes.GET_PULISHED_POSTS_ATTEMPT);
export const getPublishedPostsSuccess = createAction(GooglePostActionTypes.GET_PULISHED_POSTS_SUCCESS, props<{ publishedPosts: any }>());
export const getPublishedPostsFailure = createAction(GooglePostActionTypes.GET_PULISHED_POSTS_FAILURE, props<{ error }>());
